// extracted by mini-css-extract-plugin
module.exports = {"recipientContainer":"Home_recipientContainer__1PtDQ","column":"Home_column__NhSIV","confirmation_cta":"Home_confirmation_cta__2sMn3"};